<template>
  <!-- 融资担保卡户经理查询结果页 -->
  <div class="wrapper">
    <div class="mainbox1">
      <van-nav-bar
        class="nav"
        title="缴费信息"
        left-arrow
        fixed
        @click-left="btnleft"
      />
      <div class="mainContentBox">
        <div class="tab_wraper">
          <div
            class="tab_item"
            @click.prevent="changeTab(index)"
            :class="[active == index ? 'act_tab' : '']"
            v-for="(item, index) in picker"
            :key="index"
          >
            {{ item.label }}
          </div>
        </div>
        <van-pull-refresh
          v-model="refreshing"
          @refresh="onRefresh"
          head-height="120"
          :class="['refreshBox']"
        >
          <div class="cont">
            <div v-if="dataList.length > 0">
              <List
                :dataList="dataList"
                @handleItem="handleItem"
                @handleEdit="handleEdit"
                @handleSelect="handleSelect"
                :isLogin="true"
                :total="total"
              ></List>
              <div class="replay" @click="handlePage">
                <div v-if="dataList.length < total">
                  <div v-if="pageLoading">
                    <van-loading size="24px">加载中...</van-loading>
                  </div>
                  <div v-else><van-icon name="replay" />点击加载更多数据</div>
                </div>
                <div v-else>暂无更多数据</div>
              </div>
            </div>
            <div v-else class="nodata">
              <van-loading
                size="24px"
                v-if="dataList.length == 0 && loading && refreshing == false"
                >加载中...</van-loading
              >
              <div v-if="dataList.length == 0 && !loading">暂无数据</div>
            </div>
          </div>

          <CustomFoot
            :typeName="'12'"
            :isHome="false"
            class="zdyfooter"
            color="#297bf4"
            state="2"
          >
          </CustomFoot>
          <!-- <Foot
            v-if="list && list.bottomMessage && list.bottomMessage.length > 0"
            :list="list"
          ></Foot> -->
        </van-pull-refresh>
      </div>
      <div class="btnBoxPay" v-if="active == 0 && dataList.length >= 0">
        <div class="totalWord">
          <span class="word">合计(元)：</span>
          <span class="mon">{{ payAmtNotice }}</span>
        </div>
        <van-button
          round
          block
          type="info"
          v-if="active == 0 && dataList.length >= 0"
          :disabled="codeBtnDisabled"
          @click="getCode"
          class="btn"
          >生成二维码</van-button
        >
      </div>
      <!-- <van-tabs
      v-model="active"
      swipeable
      animated
      color="#1989fa"
     @change="changeTab"
    >
      <van-tab v-for="(item,index) in picker" :key="index" :title="item.label">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" head-height="120" class="refreshBox">
          <div class="cont">
            <div v-if="dataList.length>0" >
              <List
                :dataList="dataList"
                @handleItem="handleItem"
                @handleEdit='handleEdit'
                @handleSelect="handleSelect"
                :isLogin='true'
                :total='total'
              ></List>
              <div class="replay" @click="handlePage">
                <div v-if="hasmore">
                  <div v-if="pageLoading">
                    <van-loading size="24px">加载中...</van-loading>
                  </div>
                  <div v-else>
                    <van-icon name="replay" />点击加载更多数据
                  </div>
                </div>
                <div v-else>暂无更多数据</div>
              </div>
            </div>
            <div v-else class="nodata">
              <van-loading
                size="24px"
                v-if="dataList.length==0 && loading && refreshing==false"
              >加载中...</van-loading>
              <div v-if="dataList.length==0 && !loading">暂无数据</div>
            </div>
          </div>
          <van-button
            round
            block
            type="info"
            v-if="active==0 &&  dataList.length>0"
            :disabled='codeBtnDisabled'
            @click="getCode"
            class="btn"
          >生成二维码</van-button>
          <Foot v-if="footList && footList.bottomMessage && footList.bottomMessage.length>0" :list="footList"></Foot>
        </van-pull-refresh>
      </van-tab>
    </van-tabs> -->

      <!-- 右侧弹出弹出层__编辑侧边弹框 -->
      <van-popup
        v-model="showEdit"
        position="right"
        :style="{ height: '100%', width: '90%' }"
        class="maxContainer"
      >
        <van-form class="mainForm">
          <div v-for="(item, index) in formData" :key="index">
            <!-- 输入框文本 -->
            <van-field
              label-width="3.5rem"
              v-if="item.type == 'input'"
              v-model="saveInfo[item.value]"
              :label="item.label"
              :placeholder="item.placeholder"
              :disabled="item.disabled"
            />
            <!-- 输入框数字-->
            <van-field
              label-width="3.5rem"
              v-if="item.type == 'number'"
              type="number"
              v-model="saveInfo[item.value]"
              :label="item.label"
              :placeholder="item.placeholder"
              :disabled="item.disabled"
              @blur="changeMoney(item)"
            >
              <template #button v-if="item.value == 'loanRate'"> % </template>
            </van-field>

            <div v-if="item.type == 'select'">
              <van-field
                label-width="3.5rem"
                readonly
                clickable
                right-icon="arrow"
                :value="derate"
                :label="item.label"
                :placeholder="item.placeholder"
                @click="showPicker = true"
              />
              <van-popup v-model="showPicker" position="bottom">
                <van-picker
                  value-key="label"
                  show-toolbar
                  :columns="columns"
                  @confirm="onConfirmSelect($event)"
                  @cancel="showPicker = false"
                  :default-index="defaultIndex"
                />
              </van-popup>
            </div>
          </div>
        </van-form>
        <van-button
          class="btnBox"
          type="info"
          size="large"
          @click="save"
          :disabeld="disabledBtn"
          >确认修改</van-button
        >
      </van-popup>

      <!-- 查看详情弹窗 -->
      <!-- <van-dialog v-model="showDetail" title="收费项目明细">
        <div class="content">
          <div v-for="(item, index) in detailForm" :key="index">
            <span>{{ item.label }}</span
            >:
            <span
              >{{
                item.value == "derate" && saveInfo[item.value] == true
                  ? "是"
                  : item.value == "derate" && saveInfo[item.value] == false
                  ? "否"
                  : saveInfo[item.value]
              }}
              {{
                item.value == "loanAmount" ||
                item.value == "shouldGuaranteeFee" ||
                item.value == "derateFee" ||
                item.value == "actualGuaranteeFee"
                  ? "元"
                  : ""
              }}
            </span>
          </div>
        </div>
      </van-dialog> -->
      <ShowDetailDialog
        :info="saveInfo"
        :vde="vde"
        @closeDialog="closeDialog"
        :isShowDetail="isShowDetail"
      ></ShowDetailDialog>

      <!-- 缴费二维码 -->
      <!-- <div class="codedialog">
        <van-dialog
          v-model="QrcodeDialogVisible"
          title="二维码生成成功，请尽快付款"
        >
          <div class="payunit">
            <p>客户名称：{{ saveInfo.clientName }}</p>
          </div>
          <div
            id="qrCode"
            ref="qrCodeDiv"
            style="margin: 0 auto; width: 200px"
          ></div>
          <div class="codefoot">
            <p>实缴担保费金额：{{ saveInfo.actualGuaranteeFee }}元</p>
            <p>支持支付宝、微信扫码</p>
          </div>
        </van-dialog>
      </div> -->
      <div class="codedialog">
        <van-popup
          v-model="QrcodeDialogVisible"
          round
          :close-on-click-overlay="false"
          :get-container="getContainer"
        >
          <div class="wrap">
            <div class="contentQR">
              <div class="ti">
                <div class="tiLogo">
                  <div
                    id="qrCode"
                    ref="qrCodeDiv"
                    style="margin: 0 auto; width: 150px;margin-top: -10px;"
                  ></div>
                </div>
                <!-- 支付提醒 -->
                <!-- <div class="close" @click="closeDialog">×</div> -->
              </div>
              <div class="qrCenter">支持支付宝、微信扫码</div>
              <div class="qrContent">

                <div class="qc_bot">
                  <span>实缴担保费金额</span>
                  <span class="qc_money">{{ payAmtNotice }}</span>
                </div>
              </div>
              <div class="butarea">
                <!-- <div class="rbutton cancel">取消支付</div> -->
                <van-button
                  @click="QrcodeDialogVisible = false"
                  block
                  class="confirm"
                  round
                  type="info"
                  >确认
                  <img
                    class="blueSha"
                    src="../../assets/img/blueshadow.png"
                    alt=""
                  />
                </van-button>
              </div>

            </div>
          </div>
        </van-popup>
      </div>
    </div>
  </div>
</template>

<script>
// 客户经理查询页面
import Foot from "@/components/foot";
import Head from "@/components/head";
import List from "@/components/listFinancing";
import QRCode from "qrcodejs2";
import { Toast, Dialog, Notify } from "vant";
import { isEmpty } from "@/utils/common.js";
import { judgeVde } from "@/utils/publicJudge";
import CustomFoot from "@/components/customFoot";
import ShowDetailDialog from "@/components/showDetailDialogFinanc";

export default {
  components: {
    List,
    CustomFoot,
    ShowDetailDialog,
  },
  data() {
    return {
      payAmtNotice: "0.00",
      queryInfo: {
        searchType: 2,
        clientIdCard: "",
        isConfirm: 0,
        clientManager: JSON.parse(sessionStorage.getItem("user")).userName,
        page: 1,
        limit: 5,
      },
      vde: "",
      logo: sessionStorage.getItem("logoImg"),
      footList: JSON.parse(sessionStorage.getItem("footList")),
      dataList: [], //列表数据
      total: 0,
      picker: [
        { label: "未支付", value: 0 },
        { label: "已支付", value: 1 },
      ],
      active: 0,
      refreshing: false,
      hasmore: true,
      loading: true,
      pageLoading: false, //加载态
      showEdit: false, //编辑弹出层
      saveInfo: {},
      formData: [
        {
          type: "input",
          label: "客户名称",
          value: "clientName",
          placeholder: "请输入客户名称(必填)",
          isMust: true,
        },
        {
          type: "input",
          label: "客户证件号码",
          value: "clientIdCard",
          placeholder: "请输入客户证件号码(必填)",
          isMust: true,
        },
        {
          type: "number",
          label: "客户联系方式",
          value: "clientPhone",
          placeholder: "请输入客户联系方式",
          isMust: false,
        },
        {
          type: "input",
          label: "贷款银行",
          value: "loanBank",
          placeholder: "请输入贷款银行(必填)",
          isMust: true,
        }, //(目前直接输入，后续考虑数据字典)
        {
          type: "number",
          label: "贷款利率(%)",
          value: "loanRate",
          placeholder: "请输入贷款利率(必填)",
          isMust: true,
        },
        {
          type: "number",
          label: "贷款年限",
          value: "loanTerm",
          placeholder: "请输入贷款年限(必填)",
          isMust: true,
        },
        {
          type: "number",
          label: "拟发放贷款金额(元)",
          value: "loanAmount",
          placeholder: "请输入拟发放贷款金额(必填)",
          isMust: true,
        },
        {
          type: "number",
          label: "应缴担保费金额(元)",
          value: "shouldGuaranteeFee",
          placeholder: "应缴担保费金额(必填)",
          disabled: false,
          isMust: true,
        },
        {
          type: "select",
          label: "收费减免",
          value: "derate",
          placeholder: "请选择收费减免(必填)",
          disabled: false,
          isMust: false,
        },
        {
          type: "number",
          label: "减免金额(元)",
          value: "derateFee",
          placeholder: "减免金额(必填)",
          disabled: false,
          isMust: true,
        },
        {
          type: "number",
          label: "实缴担保费金额(元)",
          value: "actualGuaranteeFee",
          placeholder: "实缴担保费金额(必填)",
          disabled: false,
          isMust: true,
        },
      ],
      showPicker: false,
      derate: "否",
      columns: [
        { label: "是", value: true, index: 0 },
        { label: "否", value: false, index: 1 },
      ],
      codeBtnDisabled: true,
      disabledBtn: false, // 按钮禁用
      defaultIndex: 1,
      isShowDetail: false,
      showDetail: false, //查看详情弹框
      detailForm: [
        { label: "客户名称", value: "clientName" },
        { label: "客户证件号码", value: "clientIdCardDesen" },
        { label: "客户联系方式", value: "clientPhoneDesen" },
        { label: "贷款银行", value: "loanBank" }, //(目前直接输入，后续考虑数据字典)
        { label: "贷款利率(%)", value: "loanRate" },
        { label: "贷款年限", value: "loanTerm" },
        { label: "拟发放贷款金额", value: "loanAmount" },
        { label: "应缴担保费金额", value: "shouldGuaranteeFee" },
        { label: "收费减免", value: "derate" },
        { label: "减免金额", value: "derateFee" },
        { label: "实缴担保费金额", value: "actualGuaranteeFee" },
        { label: "客户经理", value: "clientManagerName" },
        { label: "客户经理电话", value: "clientManagerPhone" },
      ],
      QrcodeDialogVisible: false, //二维码弹窗
    };
  },
  created() {
    this.vde = this.$route.query.vde ? this.$route.query.vde : "";
    this.queryInfo.clientIdCard = this.$route.query.clientIdCard
      ? this.$route.query.clientIdCard
      : "";
    this.getData();
  },
  destroyed() {
    Toast.clear();
  },
  methods: {
    getContainer() {
      return document.querySelector(".codedialog");
    },
    closeDialog() {
      this.saveInfo = {};
      this.isShowDetail = false;
    },
    btnleft() {
      this.$router.go(-1);
    },
    // 从查询页进来的
    getData() {
      if (this.queryInfo.page == 1) {
        this.dataList = [];
        this.loading = true;
      } else {
        this.pageLoading = true;
      }
      return new Promise((resolve) => {
        this.request({
          url: "/guarantee/listOrderByParams",
          method: "post",
          data: this.queryInfo,
        }).then((res) => {
          this.loading = false;
          this.pageLoading = false;
          if (res.data.code == 1000) {
            if (res.data.result != null) {
              this.dataList = this.dataList.concat(res.data.result.list);
              this.total = res.data.result.total;
              if (this.total == 1) {
                this.$set(this.dataList[0], "checked", true);
                this.codeBtnDisabled = false;
                this.saveInfo = this.dataList[0];
                this.payAmtNotice =
                  "¥ " + Number(this.dataList[0].actualGuaranteeFee).toFixed(2);
              } else {
                this.dataList.forEach((item) => {
                  this.$set(item, "checked", false);
                });
              }
            }
            this.$forceUpdate();
          } else {
            if (!res.data.errorMessage) {
              // Dialog.alert({
              //   title: "提示",
              //   message: res.data.message,
              // }).then(() => {});
              this.$CDialog({
                confirmBtnText: "确定", //按钮文字
                title: "提示", //title提示文字
                message: res.data.message, //弹窗内容
                status: "2", //显示哪种图   1 为绿色   2为蓝色
                textSize: "16", // 字体大小，默认12
              }).then((res) => {});
            }
          }
          resolve();
        });
      });
    },
    // changeTab(e) {
    //     this.queryInfo.isConfirm = e;
    //     this.hasmore = true;
    //     this.dataList = [];
    //     this.queryInfo.page = 1;
    //     this.queryInfo.limit = 5;
    //     this.getData()
    // },
    changeTab(e) {
      if (this.loading || this.pageLoading) {
        // Dialog.alert({
        //   title: "提示",
        //   message: "还有数据正在加载，请稍后切换导航...",
        // }).then(() => {
        // });
        this.$CDialog({
          confirmBtnText: "确认",
          title: "提示",
          status: "2",
          textSize: 16,
          message: "还有数据正在加载，请稍后切换导航...",
        }).then((res) => {});
        this.active = e == 1 ? 0 : 1;

        return;
      }
      this.active = e;
      this.queryInfo.isConfirm = e;
      this.hasmore = true;
      this.dataList = [];
      this.queryInfo.page = 1;
      this.queryInfo.limit = 5;
      this.getData();
    },
    // 子传父的参数（用于弹窗）
    handleItem(item) {
      this.saveInfo = item;
      this.isShowDetail = true;
    },
    // 下拉刷新
    async onRefresh() {
      this.queryInfo.page = 1;
      this.queryInfo.limit = 5;
      this.dataList = [];
      this.loading = true;
      await this.getData();
      this.hasmore = true;
      this.refreshing = false;
      await Toast("刷新成功");
    },

    // 分页
    handlePage() {
      this.pageLoading = true;
      if (this.dataList.length < this.total) {
        this.queryInfo.page++;
        this.getData();
      } else {
        setTimeout(() => {
          this.pageLoading = false;
          this.hasmore = false;
        }, 500);
      }
    },
    handleEdit(item) {
      // this.showEdit = true;
      this.saveInfo = item;
      // editFin
      this.derate = this.saveInfo.derate ? "是" : "否";
      this.defaultIndex = this.saveInfo.derate ? 0 : 1;
      sessionStorage.setItem('financInfo',JSON.stringify(this.saveInfo));
      this.$router.push({
        path:'/financing/editFin',
        query:{
          derate:this.derate,
          defaultIndex:this.defaultIndex
        }
      });
    },
    onConfirmSelect(val) {
      this.derate = val.label;
      this.saveInfo.derate = val.value;
      this.defaultIndex = val.index;
      this.showPicker = false;
      // this.calculateGuaranteeOrder()
    },
    changeMoney(item) {
      if (item.value == "loanAmount") {
        // this.calculateGuaranteeOrder()
      }
    },
    // 计算金额
    calculateGuaranteeOrder() {
      this.request({
        url: "/guarantee/calculateGuaranteeOrder",
        method: "post",
        data: {
          loanAmount: this.saveInfo.loanAmount,
          derate: this.saveInfo.derate,
        },
      }).then((res) => {
        if (res.data.code == 1000) {
          this.saveInfo.shouldGuaranteeFee = res.data.result.shouldGuaranteeFee;
          this.saveInfo.derateFee = res.data.result.derateFee;
          this.saveInfo.actualGuaranteeFee = res.data.result.actualGuaranteeFee;
        } else {
          if (!res.data.errorMessage) {
            // Dialog.alert({
            //   title: "提示",
            //   message: res.data.message,
            // }).then(() => {});
            this.$CDialog({
              confirmBtnText: "确认",
              title: "提示",
              status: "2",
              textSize: 16,
              message: res.data.message,
            }).then((res) => {});
          }
        }
      });
    },
    save() {
      let bool = false;
      this.formData.find((item) => {
        if (item.isMust && this.saveInfo[item.value] == "") {
          Notify({ type: "danger", message: "请填写" + item.label });
          bool = true;
        }
      });
      if (bool) return;
      let testPhone = /^1\d{10}$/;
      let testIdcard =
        /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)|(^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$)/;
      if (
        !testPhone.test(this.saveInfo.clientPhone) &&
        !isEmpty(this.saveInfo.clientPhone)
      ) {
        Notify({ type: "danger", message: "联系电话格式不正确" });
        return;
      }
      if (
        !testIdcard.test(this.saveInfo.clientIdCard) &&
        !isEmpty(this.saveInfo.clientIdCard)
      ) {
        Notify({ type: "danger", message: "证件号码格式不正确" });
        return;
      }
      this.loading = true;
      this.request({
        url: "/guarantee/editGuaranteeOrder",
        method: "post",
        data: this.saveInfo,
      }).then((res) => {
        if (res.data.code == "1000") {
          Toast.success(res.data.message);
          this.showEdit = false;
          this.getData();
        } else {
          this.loading = false;
          if (!res.data.errorMessage) {
            // Dialog.alert({
            //   title: "提示",
            //   message: res.data.message,
            // }).then(() => {});
            this.$CDialog({
              confirmBtnText: "确认",
              title: "提示",
              status: "2",
              textSize: 16,
              message: res.data.message,
            }).then((res) => {});
          }
        }
      });
    },
    handleSelect(item) {
      this.saveInfo = item;
      this.dataList.forEach((val, index) => {
        val.checked = false;
      });
      item.checked = true;
      this.codeBtnDisabled = false;
      this.payAmtNotice = "¥ " + Number(item.actualGuaranteeFee).toFixed(2);
    },
    getCode() {
      let bool = this.dataList.some((val) => {
        return val.checked;
      });
      if (!bool) {
        // Dialog.alert({
        //   title: "提示",
        //   message: "请选择需要缴费的项目",
        // }).then(() => {});
        this.$CDialog({
          confirmBtnText: "确认",
          title: "提示",
          status: "2",
          textSize: 16,
          message: "请选择需要缴费的项目",
        }).then((res) => {});
        return;
      }

      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      this.request({
        url: "/guarantee/qrcodeUrlGuaranteeOrder",
        method: "get",
        params: { id: this.saveInfo.id },
      }).then((res) => {
        Toast.clear();
        if (res.data.code === 1000) {
          // 获取返回的二维码连接地址
          this.QrcodeDialogVisible = true;
          setTimeout(() => {
            document.getElementById("qrCode").innerHTML = "";
            new QRCode(this.$refs.qrCodeDiv, {
              text: res.data.result.qrCodeUrl,
              width: 156,
              height: 156,
              colorDark: "#333333", // 二维码颜色
              colorLight: "#ffffff", // 二维码背景色
              correctLevel: QRCode.CorrectLevel.L, // 容错率，L/M/H
            });
          }, 100);
          setTimeout(() => {
            $(".codedialog .van-dialog__header").css({
              background: "#1989fa",
              color: "#fff",
            });
          });
        } else {
          if (!res.data.errorMessage) {
            // Dialog.alert({
            //   title: "提示",
            //   message: res.data.message,
            // }).then(() => {});
            this.$CDialog({
              confirmBtnText: "确认",
              title: "提示",
              status: "2",
              textSize: 16,
              message: res.data.message,
            }).then((res) => {});
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.zdyfooter {
  margin-top: 30px !important;
}
.mainbox1 {
  background: #fff;
  ::v-deep .van-loading__text {
    color: #fff !important;
  }
  ::v-deep .van-pulling__text {
    color: #fff !important;
  }
  ::v-deep .van-pull-refresh__head {
    color: #fff !important;
  }
  ::v-deep .van-loosing__text {
    color: #fff !important;
  }
  ::v-deep .van-nav-bar {
    background: transparent !important;
  }
  ::v-deep .van-hairline--bottom::after {
    border: none !important;
  }
  ::v-deep .van-nav-bar__title {
    color: #fff;
  }
  ::v-deep .van-icon-arrow-left {
    color: #fff;
  }
  padding: 0 15px;
  padding-top: 46px;
  box-sizing: border-box;
  position: relative;
  background: url("../../assets/img/queryBW.png") no-repeat;
  background-size: cover;
  min-height: 100vh;
  ::v-deep .van-tabs__nav {
    background-color: transparent;
    opacity: 1;

    font-size: 16px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: right;
    font-weight: 400;
  }
  ::v-deep .van-tab {
    color: rgba(255, 255, 255, 0.8);
  }
  ::v-deep .van-tab--active {

    font-size: 20px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: right;
    font-weight: 500;
    .van-tab__text {
      opacity: 1;
    }
  }
  ::v-deep .van-tabs__line {
    background-color: #fff !important;
  }
  .modelBox {
    width: 100vw;
    height: 100vh;
    background: #000;
    opacity: 0.4;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
  }
  .mainContentBox {
    position: relative;
    .tab_wraper {
      margin-top: 6px;
      width: 345px;
      height: 44px;
      margin-bottom: 8px;
      display: flex;
      align-items: flex-end;
      justify-content: space-around;
      .tab_item {
        opacity: 0.8;

        font-size: 16px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: right;
        font-weight: 500;
        // padding-left: 30px;
        box-sizing: border-box;
      }
      .tab_item.act_tab {
        opacity: 1;

        font-size: 20px;
        color: #208fff;
        letter-spacing: 0;
        text-align: right;
        font-weight: 500;
      }
      .tab_item:nth-of-type(1) {
        text-align: center;
        line-height: 40px;
        width: 189px;
        height: 40px;
        background: url("../../assets/img/notpayTab.png") no-repeat;
        background-size: 100% 100%;
        padding-right: 25px;
        box-sizing: border-box;
      }

      .tab_item:nth-of-type(2) {
        text-align: center;
        line-height: 40px;
        width: 189px;
        height: 40px;
        background: url("../../assets/img/paidTab.png") no-repeat;
        background-size: 100% 100%;
        padding-left: 30px;
        box-sizing: border-box;
      }
      .tab_item:nth-of-type(1).act_tab {
        text-align: left;
        line-height: 44px;
        padding-left: 56px;
        box-sizing: border-box;
        width: 199px;
        height: 44px;
        background: url("../../assets/img/actTab.png") no-repeat;
        background-size: 100% 100%;
        margin-right: -43px;
      }
      .tab_item:nth-of-type(2).act_tab {
        text-align: right;
        line-height: 44px;
        padding-right: 56px;
        box-sizing: border-box;
        width: 199px;
        height: 44px;
        background: url("../../assets/img/actPayTab.png") no-repeat;
        background-size: 100% 100%;
        margin-left: -43px;
      }
    }
    .step1Img {
      position: absolute;
      width: 300px;
      z-index: 101;
      left: 0;
      top: -55px;
    }
    .step4Img {
      position: absolute;
      width: 250px;
      z-index: 101;
      left: 120px;
      top: -65px;
    }
    .step6Img {
      position: absolute;
      width: 250px;
      z-index: 101;
      left: 110px;
      top: -10px;
    }
    .step2Img {
      position: absolute;
      width: 300px;
      z-index: 101;
      left: 70px;
      top: 170px;
    }
    .step5Img {
      position: absolute;
      width: 200px;
      z-index: 101;
      left: 90px;
      top: 210px;
    }
  }
  .btnBox {
    position: relative;
    .step3Img {
      position: absolute;
      width: 380px;
      z-index: 101;
      left: -6px;
      top: -110px;
    }
    > .btn {
      background-image: linear-gradient(-45deg, #54adfb 0%, #297bf4 100%);

      border: none;
      outline: none;
      font-size: 18px;
      white-space: nowrap;
      .blueSha {
        width: 324px;
        height: 34px;
        position: absolute;
        left: 50%;
        top: 68%;
        transform: translateX(-50%);
      }
    }
  }
}

.nodata {
  text-align: center;
  font-size: 15px;
  margin: 30px 0;
  color: #fff;
  ::v-deep .van-loading__text {
    color: #fff !important;
  }
  ::v-deep .van-loading__circular {
    color: #fff;
  }
}
.cont {
  margin-top: 10px;
  position: relative;
  .replay {
    text-align: center;
    color: #7e7e7e;
    margin-bottom: 20px;
    position: relative;
    z-index: 100;
  }
}
.content {
  text-align: left;
  padding: 15px 10px;
  line-height: 24px;
  max-height: 120px;
  overflow-y: scroll;
}
.btn {
  margin: 20px 0;
}
.paymentSelect {
  padding: 20px;
  text-align: center;
  .van-radio {
    margin: 10px 0;
  }
}
.ticketSelect {
  text-align: center;
  .van-radio-group {
    display: inline-block;
  }
  .van-radio {
    margin: 10px 0;
  }
}
.refreshBox {
  max-height: 88vh;
  overflow-y: scroll;
  padding-bottom: 64px;
  box-sizing: border-box;
}
.refreshBox.reBox {
  max-height: 94vh;
}
.refreshBox.srb {
  padding-bottom: 40px;
  max-height: 94vh;
}
.refreshBox.rb {
  // max-height: 100vh;
  padding-bottom: 0px;
}
.refreshBox::-webkit-scrollbar {
  display: none;
}

.btnBoxPay {
  display: flex;
  align-items: center;
  background: #fff;
  padding: 0 10px;
  height: 64px;
  width: 100%;
  justify-content: space-between;
  box-sizing: border-box;
  position: fixed;
  bottom: 0px;
  left: 0px;
  z-index: 202;
  > div {
    width: 60%;
    > span:nth-of-type(1) {
      font-size: 14px;
    }
    > span:nth-of-type(2) {
      color: #f7b500;
      font-size: 20px;
    }
  }
  .totalWord {

    font-size: 12px;
    color: #464a4c;
    letter-spacing: 0;
    font-weight: 400;
    display: flex;
    align-items: center;
    .word {
      margin-left: 8px;

      font-size: 12px;
      color: #464a4c;
      letter-spacing: 0;
      font-weight: 400;
    }
    .mon {

      font-size: 14px;
      color: #f46c6c;
      letter-spacing: 0;
      font-weight: 500;
    }
  }
  .btn {
    width: 110px;
    height: 40px;
    background-image: linear-gradient(-45deg, #54adfb 0%, #297bf4 100%);
    border-radius: 22px;

    font-size: 16px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
    font-weight: 500;
    border: none;
    white-space: nowrap;
    position: relative;
    .blueSha {
      width: 324px;
      height: 34px;
      position: absolute;
      left: 50%;
      top: 68%;
      transform: translateX(-50%);
    }
  }
}

.billDetails {
  > h2 {

    font-size: 24px;
    color: #464a4c;
    letter-spacing: 0;
    text-align: right;
    font-weight: 400;
    text-align: center;
    padding: 30px 0;
  }
  .billDetails_body {
    display: flex;
    justify-content: space-between;
    margin: 0 25px;
    margin-bottom: 30px;
    height: 100px;
    align-items: center;
    padding: 0 20px;
    background: rgba(48, 186, 129, 0.1);
    border-radius: 10px;
    h2 {

      font-size: 20px;
      // color: #FFFFFF;
      letter-spacing: 0;
      font-weight: 500;
    }
  }
  //  linear-gradient(
  //     115deg,
  //     #2daf72 0%,
  //     #30bf83 42%,
  //     #37cf94 94%
  //   )
  .billDetails_body_active {
    background-image: linear-gradient(
      -45deg,
      #54adfb 0%,
      #297bf4 100%
    ) !important;
  }
}
.codedialog {
  ::v-deep .van-popup {
    background-color: transparent;
  }
}
.contentQR {
  width: 344px;
  .qrContent {
    width: 304px;
    margin: 0 auto;
    .qc_top {
      height: 44px;
      border-bottom: 1px solid #eeeeee;
      display: flex;
      justify-content: space-between;
      padding: 12px 14px;
      box-sizing: border-box;

      font-size: 14px;
      color: #464a4c;
      letter-spacing: 0;
      font-weight: 400;
    }
    .qc_bot {
      height: 44px;
      display: flex;
      justify-content: space-between;
      padding: 12px 14px;
      padding-bottom: 20px;
      box-sizing: border-box;

      font-size: 14px;
      color: #464a4c;
      letter-spacing: 0;
      font-weight: 400;
      .qc_money {

        font-size: 14px;
        color: #f46c6c;
        letter-spacing: 0;
        text-align: right;
        font-weight: 500;
      }
    }
  }
  .qrCenter {
    background: #f1f1f1;
    border-radius: 10px;
    width: 304px;
    height: 44px;
    margin: 0 auto;
    margin-top: 146px;
    margin-bottom: 12px;

    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #464a4c;
    letter-spacing: 0;
    font-weight: 400;
  }
  // border-radius: 8px;
  // position: absolute;
  // top: 50%;
  // left: 50%;
  // width: 72%;
  // max-height: 75%;
  // transform: translate(-50%, -50%);
  // background: #fff;
  // text-align: left;
  // line-height: 24px;
  // ::v-deep .van-divider {
  //   background: rgb(235, 235, 235) !important;
  // }
  height: 100%;
  background: #fff;
  border-radius: 0.42667rem;
}
.butarea {
  // display: flex;
  padding: 20px 6px;
  padding-bottom: 10px;
  text-align: center;
  padding-top: 0px;
  // position: absolute;
  // bottom: 40px;
  // left: 50%;
  // transform: translateX(-50%);
  ::v-deep .van-button--info {
    border: none !important;
    outline: none !important;
  }
  // justify-content: space-around;
  .confirm {
    width: 305px;
    height: 44px;
    color: #fff !important;
    background-image: linear-gradient(-45deg, #54adfb 0%, #297bf4 100%);
    border-radius: 22px;
    margin: 0 auto;

    font-size: 18px;
    color: #ffffff;
    letter-spacing: 0;
    font-weight: 700;
    position: relative;
    .blueSha {
      width: 286px;
      height: 34px;
      position: absolute;
      left: 50%;
      top: 68%;
      transform: translateX(-50%);
    }
  }
}
.wrap {
  padding-top: 50px;
  height: 367px;
}

.ti {
  position: relative;
  // text-align: center;
  // position: absolute;
  // top: 4%;
  // left: 50%;
  // z-index: 1001;
  // width: 86%;
  // transform: translateX(-50%);
  font-size: 16px;
  // color: #fff;
  padding: 18px 0px;
  border-radius: 8px 8px 0px 0px;
  // background: url("../assets/img/zfnotice.png");
  // background-size: cover;
  ::v-deep .van-divider {
    margin: 10px 0px !important;
    background: rgb(235, 235, 235) !important;
  }
  #qrCode {
  }
  .tiLogo {
    position: absolute;
    width: 310px;
    height: 205px;
    left: 50%;
    top: -122%;
    box-sizing: border-box;
    transform: translateX(-50%);
    z-index: 9999;
    background: url("../../assets/img/tyQrcode.png") no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>

<!-- <style lang="scss" scoped>
.mainbox {
  padding: 0 2vw;
  box-sizing: border-box;
}
.nodata {
  text-align: center;
  font-size: 15px;
  margin: 30px 0;
  color: #888;
}
.cont {
  margin-top: 10px;
  position: relative;
  .replay {
    text-align: center;
    color: #7e7e7e;
    margin-bottom: 20px;
  }

}
.content {
  padding: 15px 0;
  line-height: 24px;
  span {
      display: inline-block;
  }
    span:nth-of-type(1) {
        width: 40%;
        text-align: right;
    }
    span:nth-of-type(2) {
        width: 55%;
        text-align-last: left;
    }
}
.radioContent {
  padding: 15px 0 0 100px;
  .van-radio {
    text-align: center;
    margin-bottom: 10px;
  }
}
.btn {
  margin: 20px 0;
}
// .mainForm {
//     margin-top: 40px;
// }
.btnBox {
    // position: fixed;
    // bottom: 0;
    // left: 0;
    min-height: 50px;
}
// 使用弹性布局
.maxContainer{
  display: flex;
  justify-content: space-between;
  flex-direction:  column;
}
.payunit {
  background: #1989fa;
  color: #fff;
  text-align: center;
  margin-bottom: 10px;
  padding: 10px;
  position: relative;
  top: -1px;
  font-weight: bold;
}
.codefoot {
  text-align: center;
  > p:nth-of-type(1) {
    font-weight: bold;
    color: #ee0a24;
    margin-top: 20px;
  }
  > p:nth-of-type(2) {
    color: #888;
    margin-top: 10px;
    font-size: 12px;
  }
}
.refreshBox {
  max-height:80vh;
  overflow-y: scroll;
}
.refreshBox::-webkit-scrollbar {
  display: none;
}


</style> -->
